import { Route, Routes } from "@angular/router";

import { sendInvitationListRoutes } from "./nested-features/send-invitation";
import { membershipDashboardRoutes } from "./nested-features/dashboard";
import { targetedMessagesListRoutes } from "./nested-features/targeted-messages";
import { sendEvaluationFormListRoutes } from "./nested-features/send-evaluation-form";
import { membershipsListRoutes, membershipsCRUDRoutes } from "./nested-features/memberships";

import { UserRole } from "src/app/core";
import { Permissions } from "src/assets/config/config";

const membershipsRoute: Route = {
  path: "memberships",
  title: "FRIENDS_OF_OMAN_MUSEUM.DEPARTMENT_PRIVILEGES",
  children: membershipsListRoutes,
};

const sendInvitationRoute: Route = {
  path: "send-invitation",
  title: "FRIENDS_OF_OMAN_MUSEUM.DEPARTMENT_PRIVILEGES",
  children: sendInvitationListRoutes,
};

const targetedMessagesRoute: Route = {
  path: "targeted-messages",
  title: "FRIENDS_OF_OMAN_MUSEUM.DEPARTMENT_PRIVILEGES",
  children: targetedMessagesListRoutes,
};

const sendEvaluationFormRoute: Route = {
  path: "send-evaluation-form",
  title: "FRIENDS_OF_OMAN_MUSEUM.DEPARTMENT_PRIVILEGES",
  children: sendEvaluationFormListRoutes,
};

const membershipDashboardRoute: Route = {
  path: "membership-dashboard",
  title: "FRIENDS_OF_OMAN_MUSEUM.DEPARTMENT_PRIVILEGES",
  children: membershipDashboardRoutes,
};

export const friendsOfOmanRoutes: Routes = [
  {
    path: "",
    title: "FRIENDS_OF_OMAN_MUSEUM.DEPARTMENT_PRIVILEGES",
    data: {
      tabs: [
        {
          key: "MembershipDashboard",
          title: "FRIENDS_OF_OMAN_MUSEUM.MEMBERSHIP_DASHBOARD",
          routerLink: "membership-dashboard",
        },
        {
          key: "Memberships",
          title: "FRIENDS_OF_OMAN_MUSEUM.MUSEUM_MEMBERS",
          routerLink: "memberships",
        },
        {
          key: "SendInvitation",
          title: "FRIENDS_OF_OMAN_MUSEUM.SEND_INVITATION",
          routerLink: "send-invitation",
        },
        {
          key: "TargetedMessages",
          title: "FRIENDS_OF_OMAN_MUSEUM.TARGETED_MESSAGES",
          routerLink: "targeted-messages",
        },
        {
          key: "SendEvaluationForm",
          title: "FRIENDS_OF_OMAN_MUSEUM.SEND_EVALUATION_FORM",
          routerLink: "send-evaluation-form",
        },
      ],
    },
    loadComponent: () =>
      import("src/app/shared/base-components/base-tabs-management/base-tabs-management.component").then(
        (c) => c.BaseTabsManagementComponent,
      ),
    children: [
      { path: "", redirectTo: "memberships", pathMatch: "full" },
      membershipsRoute,
      sendInvitationRoute,
      targetedMessagesRoute,
      sendEvaluationFormRoute,
      membershipDashboardRoute,
    ],
  },
  {
    path: "memberships",
    children: membershipsCRUDRoutes,
  },
];

export const membershipNestedRoutes: Route[] = [
  {
    path: membershipsRoute.path,
    data: {
      permissions: Permissions.Memberships.filter((role) => role !== UserRole.ADMIN),
      tabs: [
        {
          key: "Memberships",
          title: "FRIENDS_OF_OMAN_MUSEUM.MEMBERSHIPS",
          routerLink: "",
        },
      ],
    },
    loadComponent: () =>
      import("src/app/shared/base-components/base-tabs-management/base-tabs-management.component").then(
        (c) => c.BaseTabsManagementComponent,
      ),
    children: [
      {
        ...membershipsRoute,
        path: "",
      },
    ],
  },
  {
    path: sendInvitationRoute.path,
    data: {
      permissions: Permissions.Memberships.filter((role) => role === UserRole.MUSEUMFRIENDSDEPARTMENT),
      tabs: [
        {
          key: "SendInvitation",
          title: "FRIENDS_OF_OMAN_MUSEUM.SEND_INVITATION",
          routerLink: "",
        },
      ],
    },
    loadComponent: () =>
      import("src/app/shared/base-components/base-tabs-management/base-tabs-management.component").then(
        (c) => c.BaseTabsManagementComponent,
      ),
    children: [
      {
        ...sendInvitationRoute,
        path: "",
      },
    ],
  },
  {
    path: targetedMessagesRoute.path,
    data: {
      permissions: Permissions.Memberships.filter((role) => role === UserRole.MUSEUMFRIENDSDEPARTMENT),
      tabs: [
        {
          key: "TargetedMessages",
          title: "FRIENDS_OF_OMAN_MUSEUM.TARGETED_MESSAGES",
          routerLink: "",
        },
      ],
    },
    loadComponent: () =>
      import("src/app/shared/base-components/base-tabs-management/base-tabs-management.component").then(
        (c) => c.BaseTabsManagementComponent,
      ),
    children: [
      {
        ...targetedMessagesRoute,
        path: "",
      },
    ],
  },
  {
    path: sendEvaluationFormRoute.path,
    data: {
      permissions: Permissions.Memberships.filter((role) => role === UserRole.MUSEUMFRIENDSDEPARTMENT),
      tabs: [
        {
          key: "SendEvaluationForm",
          title: "FRIENDS_OF_OMAN_MUSEUM.SEND_EVALUATION_FORM",
          routerLink: "",
        },
      ],
    },
    loadComponent: () =>
      import("src/app/shared/base-components/base-tabs-management/base-tabs-management.component").then(
        (c) => c.BaseTabsManagementComponent,
      ),
    children: [
      {
        ...sendEvaluationFormRoute,
        path: "",
      },
    ],
  },
];
